import api from '../../api';

export const getAutoEmail = (templateId, rowId) => api.get(`/pre/auto_email/${templateId}/?contribution_id=${rowId}`);

export const sendAutoEmail = (templateId, emailInfo) => api.post(`/pre/auto_email/${templateId}/`, emailInfo);
